export const AuctionStateTypes = {
  draft: "draft",
  finish: "finish",
  publish: "publish",
  schedule: "schedule",
  error: "error",
  await: "await",
  confirm: "confirm",
};
